"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCookieName = makeCookieName;

function makeCookieName(name) {
  return 'ftvOption%3A' + name;
}